import { Routes } from '@angular/router';

export const AppRoutes: Routes = [{
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        children: [{
            path: '',
            loadChildren: './login/login.module#LoginModule'
        }]
    },
    {
        path: 'home',
        children: [{
            path: '',
            loadChildren: './home/home.module#HomeModule'
        }]
    }
];